import { useContext } from 'react';
import { useLoaderData, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import SmartContextPage from '../../../library/Core/SmartContextPage';
import EntrepreneurDirectoryService from './EntrepreneurDirectoryService';
import EntrepreneurSearchControl from './EntrepreneurSearchControl';
import EntrepreneurCardGridControl from './EntrepreneurCardGridControl';
import EntrepreneurSummaryCardControl from './EntrepreneurSummaryCardControl';
import '../../../styles/css/revamp_style.css';

const EntrepreneurDirectory = () => {
    const { pageName } = useParams();
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();

    const { formConfig, data, internal } = useLoaderData() as State;
    const [searchParams] = useSearchParams();
    const domain = globalState.domain;
    const filters = EntrepreneurDirectoryService.filtersFromSearchParams(searchParams, domain);
    const searchFilterDomains = EntrepreneurDirectoryService.getSearchFilterDomains(
        domain,
        (internal as any)?.searchFilterDomains
    );
    const selectedCard = filters.selectedCard || (data as any)?.selectedCard || '';

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        data: { ...(data as any), searchDomain: searchFilterDomains, filters, selectedCard },
        formConfig,
        internal: { ...(internal as any), searchFilterDomains },
        domain,
        routeInfo: { pageName },
        flags: { isDataLoading: false, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { ROUTER_NAVIGATE: navigate },
    } as any);

    return (
        <SmartContextPage state={state} dispatch={dispatch} showDebug={false}>
            <>
                <EntrepreneurSummaryCardControl />
                <EntrepreneurSearchControl />
                <EntrepreneurCardGridControl />
            </>
        </SmartContextPage>
    );
};

export default EntrepreneurDirectory;
